import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AmountWithUnitField from '../common/AmountWithUnitField';
import { fieldLabelSx, nativeInputSx } from '../common/formFieldStyles';

const ProductContentFields = ({
  contentQuantity,
  stockUnit,
  lowStockPackages,
  errors = {},
  onChange,
}) => {
  const { t } = useTranslation();
  const unitError = errors.contentQuantity || errors.stockUnit;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <AmountWithUnitField
        id="product-content-quantity"
        label={t('productsManagement.fields.contentQuantity')}
        required
        quantity={contentQuantity}
        stockUnit={stockUnit || 'Unit'}
        error={unitError ? t(unitError) : undefined}
        onQuantityChange={(nextQuantity) => onChange({ contentQuantity: nextQuantity })}
        onUnitChange={(nextUnit) => onChange(nextUnit === 'Unit'
          ? { stockUnit: nextUnit, contentQuantity: 1 }
          : { stockUnit: nextUnit })}
      />

      <Box>
        <Typography variant="subtitle2" sx={fieldLabelSx}>
          {t('productsManagement.fields.lowStockThreshold')}
        </Typography>
        <Box
          component="input"
          id="product-low-stock"
          type="number"
          min={0}
          step="0.001"
          aria-label={t('productsManagement.fields.lowStockThreshold')}
          value={lowStockPackages}
          onChange={(event) => onChange({ lowStockPackages: event.target.value })}
          sx={nativeInputSx(Boolean(errors.lowStockThreshold))}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
          {t('productsManagement.fields.lowStockHelp')}
        </Typography>
        {errors.lowStockThreshold ? (
          <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, display: 'block' }}>
            {t(errors.lowStockThreshold)}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default ProductContentFields;
